
import React, { PureComponent } from 'react';
import resl from 'resl';
// import app_cs from './App.module.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import './slick-theme.css';
import 'whatwg-fetch';
import keyBy from 'lodash.keyby';
import _ from 'lodash';
import $ from 'jquery';
import Cylinder from'./components/mCylinder';
import Disable from'./components/Disable/index.js';

// home_bg.png
// import home_title from '../../assets/images/m/home_title.png'
import cgtn from '../../assets/images/m/cgtn.png';
import home_1 from '../../assets/images/m/home_1.png';
import home_1_1 from '../../assets/images/m/home_1_1.png';
import m_1991_1 from '../../assets/images/m/m_1991_1.png';
import m_1991_2 from '../../assets/images/m/m_1991_2.png';
import m_1991_3 from '../../assets/images/m/m_1991_3.png';
import m_1991_4 from '../../assets/images/m/m_1991_4.png';
import m_1994 from '../../assets/images/m/m_1994.png';
import m_1999_1 from '../../assets/images/m/m_1999_1.png';
import m_1999_2 from '../../assets/images/m/m_1999_2.png';
import m_1999_i from '../../assets/images/m/m_1999_i.jpeg';
import m_2004 from '../../assets/images/m/m_2004.png';
import m_2008 from '../../assets/images/m/m_2008.png';
import m_2008_i from '../../assets/images/m/m_2008_i.jpeg';
import m_2009 from '../../assets/images/m/m_2009.png';
import m_2009_1 from '../../assets/images/m/m_2009_1.png';
import m_2013 from '../../assets/images/m/m_2013.png';
import m_2014 from '../../assets/images/m/m_2014.png';
import m_2019 from '../../assets/images/m/m_2019.png';
import m_2022 from '../../assets/images/m/m_2022.png';


import icon_pop from '../../assets/images/m/icon_pop.png';
import icon_gas from '../../assets/images/m/icon_gas.png';
import img_nuclear from '../../assets/images/m/img_nuclear.png';
import icon_nuclear from '../../assets/images/m/icon_nuclear.png';
import img_money from '../../assets/images/m/img_money.png';
import icon_money from '../../assets/images/m/icon_money.png';
// img_money


import img_agriculture from '../../assets/images/m/img_agriculture.png';
import img_arrow_1 from '../../assets/images/m/img_arrow_1.png';
import img_arrow_2 from '../../assets/images/m/img_arrow_2.png';
import img_arrow_3 from '../../assets/images/m/img_arrow_3.png';
import img_arrow_4 from '../../assets/images/m/img_arrow_4.png';
import img_arrow_5 from '../../assets/images/m/img_arrow_5.png';
import img_gas from '../../assets/images/m/img_gas.png';
import img_gas_arrow_1 from '../../assets/images/m/img_gas_arrow_1.png';
import img_gas_arrow_2 from '../../assets/images/m/img_gas_arrow_2.png';

import m_cgtn from '../../assets/images/m/m_cgtn.png';


import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

import './m_app.css'
gsap.registerPlugin(ScrollTrigger);

//  m_1999_1,
const images = [home_1_1, home_1_1,home_1_1,home_1_1,home_1_1, m_1991_1,m_1994, m_1999_1,m_2004,m_2008,m_2009,m_2013,m_2014,m_2019,m_2022];
// const data_map2 = keyBy(map2_json.content, obj=>obj.name)
// console.log('data_map2', data_map2)
const images_1991 = [m_1991_1,m_1991_2,m_1991_3,m_1991_4];

window.jwplayer.key = "44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK"

class M extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            onOff : true
        }
        this.currentIndex = 0;
        this.flag = {}; // 1991
        this.flag2009 = {}
        this.flag2014 = {}
        this.flag1999 = {};
    }
    componentDidMount() {
       let _this = this;
        
        $(window).resize(() => {
            _this.resize()
        }).trigger('resize')
        // 顶部滚动条 
        const scrollHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
        let content_bg = document.querySelector('.content-bg');
        // window.addEventListener('scroll',
        //  (e) => {
        //     document.querySelector('progress').value = window.pageYOffset / (scrollHeight - window.innerHeight) * 100;
        // })
        let tl2 = gsap.timeline();
        tl2.to('.m-home2',{
            duration:.8,
            // ease:'none',
            scrollTrigger:{
                trigger:'.m-home2',
                start:'top bottom-=2%',
                end:'top bottom-=3%',
                // markers:true,
                onEnter:()=>{
                    $('.m-home1').animate({opacity:0},500)
                },
                onEnterBack:()=>{
                    $('.m-home1').animate({opacity:1},500)
                }
            }
        })
          
        gsap.utils.toArray('.content-section').map((section,i)=>{
            let _leng = $(".content-section").length
            section.content = section.querySelector(".content");
            section.bg = section.querySelector(".bg");
            section.content_time = section.querySelector(".content-time");
            section.content = section.querySelector('.content');
            section.content_time_placeholder = section.querySelector('.content-time-placeholder');
            section.title_end = section.querySelector('.title-end');
            var tl = gsap.timeline();
            let data_num = $(section).attr('data-num');
            section.bg.style.backgroundImage = `url(${images[i]})`;
            if(data_num ==1991 || data_num ==1999 || data_num == 2009 || data_num == 2014 ){
                var tl2 = gsap.timeline();
                section.bg.style.opacity = 0;
                section.bg.style.backgroundImage = ''
            }
            let _height = 5.35*this.rule_num;
            tl.to(section, {
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    // pin:section.bg,
                    // pin:section.content_time,
                    start:"top bottom",
                    // start:()=>{
                    //     if(data_num ==1991){
                    //         return "top bottom-=30%";
                    //     }else{
                    //         return "top bottom";
                    //     }
                    // },
                    end: "bottom top+=10%",
                    fastScrollEnd:true,
                    preventOverlaps:true,
                    // scrub:true,
                    onUpdate:({progress})=>{
                        // console.log(this.rule_num,'this.rule_num');
                        let title_client = section.querySelector('.content').getClientRects();
                        
                        // console.log(title_client);
                        // console.log(title_client[0].y);
                        // if(!$(section.content_time).hasClass('content-time-fixed')){
                        //     console.log('1111');
                        //     if(title_client[0].y <= 0){
                        //     console.log('1111');

                        //         _.throttle(()=>{
                        //             $(section.content_time).addClass('content-time-fixed');
                        //             $(section.content_time_placeholder).css({"position":'unset'});
                        //         },200,{leading:true})
                                
                        //     }
                        // }
                        let _title_end = section.querySelector('.title-end');
                        if(_title_end && data_num != 1991){
                            let title_end = section.querySelector('.title-end').getClientRects();
                            _.throttle(()=>{
                                if(title_client[0].y <= 20){
                                    // console.log('1111');
                                    $(section.content_time).addClass('content-time-fixed');
                                    $(section.content_time_placeholder).css({"position":'unset'});
                                }
                            },300,{leading:true})();
                            _.throttle(()=>{
                                if(title_client[0].y > 4 || title_end[0].y < _height){
                                    $(section.content_time).removeClass('content-time-fixed');
                                    $(section.content_time_placeholder).css({"position":'fixed'});
                                }
                            },300,{leading:true})();
                        }
                        
                       
                        if(data_num == 1991){
                            // console.log('data_num==>', progress);
                            section.bg_1991_2 = section.querySelector('.bg-1991-2');
                            section.bg_1991_1 = section.querySelector('.bg-1991-1');
                            section.bg_1991_3 = section.querySelector('.bg-1991-3');
                            section.bg_1991_4 = section.querySelector('.bg-1991-4');
                            if(0<= progress && progress<=0.25 && !_this.flag.image1){
                                // console.log('0000');
                                tl2.to(section.bg_1991_2,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_3,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_4,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_1,{
                                    opacity:1,
                                    duration:.6,
                                },'-=0.9');
                                _this.flag= {
                                    image1:true
                                };
                            }
                            if(0.25<progress && progress<=0.5 && !_this.flag.image2){
                                // console.log('111');
                                tl2.to(section.bg_1991_1,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_3,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_4,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_2,{
                                    opacity:1,
                                    duration:1.2,
                                },'-=1');
                                _this.flag= {
                                    image2:true
                                };
                            }
                            if(0.5<progress && progress<=0.7 &&  !_this.flag.image3){
                                // console.log('222');
                                tl2.to(section.bg_1991_1,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_2,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_4,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_3,{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.6');
                                // _this.flag.image3 = true;
                                _this.flag= {
                                    image3:true
                                };
                            }
                            if(0.7<progress && progress<=1 &&  !_this.flag.image4){
                                // console.log('3333');
                                tl2.to(section.bg_1991_1,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_2,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_3,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_4,{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.7');
                                _this.flag= {
                                    image4:true
                                };
                            }
                        }
                        if(data_num == 1999){
                            if(0<= progress && progress<=0.25 && !_this.flag1999.image1){
                                section.bg_zoomOut  =  section.querySelector('.bg-zoomOut');
                                section.bg_1999  =  section.querySelector('.bg-1999');
                                section.m_1999_font  =  section.querySelector('.m_1999_font');
                                tl.to(section.bg_1999,{
                                    delay:1,
                                    opacity:0,
                                    scale:1.55,
                                    // translate(-2.6rem,-0.5rem)
                                    x:'-4rem',
                                    y:'-0.9rem',
                                    duration:2
                                }).to(section.m_1999_font,{
                                    opacity:0,
                                    duration:.3,
                                },'<').to(section.bg_zoomOut,{
                                    // delay:0.4,
                                    opacity:1,
                                    scale:1.55,
                                    x:'-4rem',
                                    y:'-0.9rem',
                                    duration:2,
                                },'-=2').to('.m_1999_2_2_front',{
                                    opacity:1,
                                    scale:1,
                                    x:'0',
                                    y:'0',
                                    duration:.8
                                },'<') 
                            }
                            _this.flag1999 = {image1:true}
                        }
                        if(data_num ==2009){
                            if(progress > 0.2 && !_this.flag2009.image1){
                                // console.log('0000');
                                // to('.bg-2009',{
                                //     opacity:0,
                                //     scale:.4,
                                //     scale:1,
                                //     duration:2,
                                // }).
                                tl2.to('.bg-2009-1',{
                                    // delay:2,
                                    // opacity:1,
                                    scale:1,
                                    x:0,
                                    duration:2,
                                });
                                _this.flag2009= {
                                    image1:true
                                };
                            }
                        }
                        if(data_num ==2014){
                            if(0<progress && progress<=0.25 &&  !_this.flag2014.image1){
                                tl2.to('.bg-2014-1',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-2',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014',{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.4');
                                _this.flag2014= {
                                    image1:true
                                };
                            }
                            if(0.25<progress && progress<=0.5 &&  !_this.flag2014.image2){
                                tl2.to('.bg-2014',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-2',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-1',{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.4');
                                _this.flag2014= {
                                    image2:true
                                };
                            }
                            if(0.5<progress &&  !_this.flag2014.image3){
                                tl2.to('.bg-2014',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-1',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-2',{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.4');
                                _this.flag2014= {
                                    image3:true
                                };
                            }
                        }
                    },
                    onEnter:()=>{
                        section.img_arrow_wraper = section.querySelector('.img-arrow-wraper');
                        if(section.img_arrow_wraper){
                            tl.from('.img-arrow-wraper img',{
                                delay:.8,
                                opacity:0,
                                scale:0,
                                stagger:0.3,
                            })
                        }
                        $(section.bg).animate({opacity:1},1000);
                    },
                    onLeaveBack:(ele)=>{
                        $(section.bg).animate({opacity:0},500);
                    },
                    onLeave:(ele)=>{
                        $(section.bg).animate({opacity:0},500);
                        $(section.content_time).removeClass('content-time-fixed');
                        $(section.content_time_placeholder).css({"position":'fixed'});
                    },
                    onEnterBack:()=>{
                        $(section.bg).animate({opacity:1},1000);
                    },
                }
            });
            section.img_agriculture = section.querySelector('.img_agriculture');
            if(section.img_agriculture){
                tl.from(section.bg,{
                    scale:.8,
                    opacity:0,
                    duration:1.2,
                })
            }
            section.img_arrow_wraper = section.querySelector('.img-arrow-wraper');
            if(section.img_arrow_wraper){
                tl.from('.img-arrow-wraper img',{
                    delay:1,
                    opacity:0,
                    scale:0,
                    stagger:0.6,
                })
            }
        })
    }
     // 调整 html 字体大小
     getScrollWidth = () => {
        let noScroll, scroll, oDiv = document.createElement("DIV");
        oDiv.style.cssText = "position:absolute; top:-9999px; width:100px; height:100px; overflow:hidden;";
        noScroll = document.body.appendChild(oDiv).clientWidth;
        oDiv.style.overflowY = "scroll";
        scroll = oDiv.clientWidth;
        document.body.removeChild(oDiv);
        return noScroll - scroll;
    }
    IsPC = () => {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
        }
        return flag;
    }
    resize = () => {
        let window_width = window.innerWidth - this.getScrollWidth();
        this.rule_num = window_width * 20 / 428;
        let pc_num = window_width * 100 / 1920;
        if (this.IsPC()) {
            $("html").css("font-size", pc_num + "px");
        }
        else {
            $("html").css("font-size", this.rule_num + "px");
        }


    }
    // shareClick(){
    //     if(this.state.onOff){
    //         $('#social_icons-magic').css('left','25px')
    //         this.setState({
    //             onOff : false
    //         })
    //     }else{
    //         $('#social_icons-magic').css('left','0')
    //         this.setState({
    //             onOff : true
    //         })
    //     }
    //     $('#social_icons').toggleClass('active')
    // }
    render() {
        return <div className='m-main'>
            <Disable />
            {/* <progress value="0" max="100"></progress> */}
            <div className="m-home-title">
                <img src={m_cgtn}/>
                <a className='m-title-conflict' href="https://news.cgtn.com/event/2022/Russia-Ukraine-Conflict-Tracker/index.html">
                    Conflict Tracker
                </a>
                <a className='m-title-change' href='https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis-CN/index.html'>EN <span>/中文</span></a>
            </div>
            <div className="m-home-wraper m-home1">
                {/* <div className="share-box" >
                    <a href="javascript:;"><img id="share_btn" onClick={()=>this.shareClick()}  className="share-btn" src={require("../../assets/images/m/share/share-btn.png")} alt="Share" /></a>
                    <div id="social_icons-magic" className="social-icons-magic"></div>
                    <div id="social_icons" className="social-icons">
                        <a className="share-fb" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https://newstest.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>
                        <a className="share-twitter" target="_blank" href="https://twitter.com/intent/tweet?text=Historical Map: Ukraine Crisis&url=https://newstest.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>
                        <a className="share-sina" target="_blank" href="http://service.weibo.com/share/share.php?appkey=4122844478&title=Historical Map: Ukraine Crisis&url=https://newstest.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>
                    </div>
                </div> */}
                
                <div className="m-home">
                    <div className="shadow_people"></div>
                    <div className="m-home-content">
                        <div className='m-home-tilte'>
                            {/* <img src={home_title}/> */}
                            <div>Historical Map:</div>
                            <div>Ukraine Crisis</div>
                        </div>
                        <div className="m-home-line"></div>
                        <div className='m-home-subtitle'>
                            Looking back at the roots of the Russia-Ukraine conflict may help us figure out a path to peace.
                        </div>
                    </div>
                    <div className={'m-cylinder-wrapper'}>
                        <Cylinder />
                    </div>
                    <div className='m-home-next'>
                        <span>Explore our project</span>
                        <span>
                            <span className='arrow_down'></span>
                        </span>
                    </div>
                </div>
            </div>
            <div className="m-home-wraper m-home2" style={{width:'100vw',height:'4vh',background:'#000',position:'relative',marginTop:'-0.1rem'}}>

            </div>
            <div className="content-wrap">
                {/* <div className='content-background-wraper'>

                </div>
                <div className="content-section-wraper">

                </div> */}
                {/* 1 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="home-content-box">
                        Ukraine is located in Eastern Europe, and used to be part of the Soviet Union, officially the Union of Soviet Socialist Republics (USSR). It is the second largest country in Europe after Russia, with which it shares a near 2,000-kilometer land border to the northeast.
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title'></div>
                        {/* <div className="content-box">
                            <div className="content-summary">
                            </div>
                        </div> */}
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}

                </section>
                {/* 2 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_agriculture">
                            <img src={img_agriculture}/>
                        </div>
                        <div className='img-arrow-wraper'>
                            <img src= {img_arrow_1}/>
                            <img src= {img_arrow_2}/>
                            <img src= {img_arrow_3}/>
                            <img src= {img_arrow_4}/>
                            <img src= {img_arrow_5}/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>Breadbasket of Europe</div>
                        <div className="content-box">
                            <div className="content-summary">
                                Ukraine boasts a quarter of the world's fertile black soil and 71 percent of the country's land is agricultural. It is the fourth largest global exporter of corn and fifth of wheat, in addition to being the world's largest exporter of sunflower oil. It produced 40 percent of the world's sunflower oil in 2020.
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}

                </section>
                {/* home-3 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_gas">
                            <img src = {icon_gas} className="icon_gas"/>
                            <img src={img_gas}/>
                        </div>
                        <div className='img-gas-arrow'>
                            <img src= {img_gas_arrow_2}/>
                            <img src= {img_gas_arrow_1}/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>Key energy supply route</div>
                        <div className="content-box">
                            <div className="content-summary">
                            Ukraine is home to a series of pipelines that are crucial to Russia-Europe energy trading. In 2021, 41.6 billion cubic meters of Russian gas were transported through Ukraine to Europe, accounting for 26.8 percent of Europe's total gas imports from Russia.
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}

                </section>
                {/* home-4 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_nuclear">
                            <img src={img_nuclear}/>
                            <img src = {icon_nuclear} className="icon_nuclear"/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>Soviet nuclear inheritor</div>
                        <div className="content-box">
                            <div className="content-summary">
                            Ukraine has four nuclear power plants (NPP), all of which were commissioned during the Soviet era. Its Zaporizhzhia plant is the largest NPP in Europe. In 2020, Ukraine generated 76,202 GWh of electricity from nuclear power, ranking seventh in the world.
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}
                </section>
                {/* 5 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_money">
                            <img src={img_money}/>
                            <img src={icon_money} className="icon_money"/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>Links with NATO members</div>
                        <div className="content-box">
                            <div className="content-summary">
                            Ukraine-NATO relations started in the early 1990s soon after the country's independence from the USSR. Ukraine is also <span style={{color:'#beab62',fontWeight:'600'}}>  one of the leading recipients of aid from NATO members.</span> From 2014 to 2021, Ukraine received more than $2.5 billion in military aid from the U.S.
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}
                </section>
                
                
                {/* 1991 */}
                <section className="content-section content-section-1991" data-num = "1991">
                    <div className="bg" style={{backgroundColor:'#000',opacity:0}}>
                        <div className="bg-1991 bg-1991-1"></div>
                        <div className="bg-1991 bg-1991-2"></div>
                        <div className="bg-1991 bg-1991-3"></div>
                        <div className="bg-1991 bg-1991-4"></div>
                    </div>
                    <div className='content'>
                        <div className="content-time">1991</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>Ukraine becomes independent</div>
                        <div className="content-box">
                            <div className="content-summary">
                            In 1991, Ukraine became an independent country after the collapse of the USSR, which was made up of 15 republics: Armenia, Azerbaijan, Belarus, Estonia, Georgia, Kazakhstan, Kyrgyzstan, Latvia, Lithuania, Moldova, Russia, Tajikistan, Turkmenistan, Ukraine and Uzbekistan. 
The Act of Independence was backed by a majority of voters in all of Ukraine's 27 administrative regions, but received a lower level of support in areas of Eastern Ukraine where there were more Russian speakers, including Luhansk, Donetsk and Crimea, as well as regions such as Kharkiv and Odesa.
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            Ukraine is bordered by Russia to the northeast and Belarus to the north, while NATO members lie to its west and south.</div>
                        </div>

                        {/* 2 */}
                        <div className="content-box" style={{marginTop:'80vh'}}>
                            <div className="content-summary">
                                <div style={{fontWeight:800}}>What is NATO ? </div>The North Atlantic Treaty Organization was created in 1949 by <span style={{color:'#beab62',fontWeight:'600'}}>the U.S., 
                                Canada and several Western European nations. </span>
                                The military alliance now includes<span style={{color:'#beab62',fontWeight:'600'}}> 30 countries.</span>
                                <div>(Map reflects the period from October 3, 1990 to June 25, 1991.)</div>
                            </div>
                        </div>
                        {/* 3 */}
                        <div className="content-box" style={{marginTop:'90vh'}}>
                            <div className="content-summary">
                            <div style={{fontWeight:800}}>What was the Warsaw Pact ?</div> The Warsaw Pact was created in 1955 after the accession of West Germany to NATO. 
                                It was composed of the Soviet Union and seven other Soviet satellite states in Central and Eastern Europe.
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            The Warsaw Pact embodied what was referred to as the Eastern bloc, 
                            while NATO represented the Western bloc. They were ideologically opposed and, over time,
                            built up their own defenses starting an arms race that lasted throughout the Cold War. 
                            The alliances were not always in conflict with one another. In 1990, Nato and Warsaw Pact states signed the Conventional Armed Forces in Europe treaty (CFE) and published a joint declaration on non-aggression. 
                            </div>
                        </div>
                        {/* 4 */}
                        <div className="content-box" style={{marginTop:'60vh'}}>
                            <div className="content-summary">
                                East Germany left the Warsaw Pact upon reunification with West Germany in 1990. The Warsaw Pact was declared at an end in 1991, and the Soviet Union collapsed that year.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>
                </section>
                {/* 1994 */}
                <section className="content-section">
                    <div className="bg"></div>
                    <div className= "bg-title bg-title-right">1994</div>
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>1994</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>Budapest Memorandum</div>
                        <div className="content-box">
                            <div className="content-summary">
                                After the collapse of the Soviet Union in 1991, 
                                the newly independent Ukraine was left in possession of the world's third-largest nuclear weapon stockpile. 
                                It had some 1,900 strategic warheads – all designed and built by the USSR.
                            </div>
                        </div>
                        <div className="content-box">
                            <div className="content-summary">
                                Belarus and Kazakhstan found themselves in similar situations.
                                Eliminating these nuclear warheads became the subject of intense interest to both Washington and Moscow. 
                                On December 5, 1994, the Budapest Memorandum was signed at the Budapest Summit of the Conference on Security and Cooperation in Europe (CSCE) to provide security assurances to Belarus, Kazakhstan and Ukraine. 
                                In exchange for the three countries giving up their nuclear weapons, 
                                the U.S., UK and Russia promised not to use military force or economic coercion against them.
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            At a NATO Foreign Ministers meeting held in Brussels earlier in the same month, 
                            the military alliance began open discussions about its expansion eastward, 
                            saying it "would welcome NATO enlargement that would reach to democratic states to our East." Russian President Boris Yeltsin was furious.  
                            At the Budapest Summit, he accused the "domineering" U.S. of "trying to split the continent again" through NATO expansion.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 1999 */}
                <section className="content-section" data-num="1999">
                    <div className="bg">
                        {/* <div className="shown_up"></div> */}
                        <div className='bg-wraper'>
                            <div className="bg-1999"></div>
                            <div className="m_1999_font"></div>
                            <div className="bg-zoomOut"></div>
                            <div className="m_1999_2_2_front"></div>
                        </div>
                        {/* <div className="shown_down"></div> */}
                    </div>
                    {/* <div className= "bg-title">1999</div> */}
                    <div className='content'>
                        <div className="content-time">1999</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>Former Warsaw Pact countries join NATO</div>
                        <div className="content-box">
                            <div className="content-summary">
                            In January 1999, NATO sent a formal invitation to the former Warsaw Pact countries of Poland,
                            Hungary and the Czech Republic to enter the alliance.
                            On March 12, 1999, the three countries officially signed up, bringing NATO's sphere of influence further to the east amid much debate within the alliance itself and fierce opposition from Russia.
                            It was the first wave of NATO expansion.
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'80vh'}}>
                            <div className='m_1999_i'>
                                <img src={m_1999_i}/>
                            </div>
                            <div className="content-summary">
                            In the same month, NATO carried out an aerial bombing campaign against the Federal Republic of Yugoslavia during the Kosovo War.
                            For Moscow, the move was a drastic provocation and rang an alarm that its efforts to maintain cordial relations with the West may have been a mistake. As former Yugoslav diplomat Vesko Garcevic pointed out, 
                            NATO's unilateral decision to bomb Yugoslavia without the UN's approval marked a turning point in Russia's relationship with the West. 
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2004 */}
                <section className="content-section">
                    <div className="bg bg-zoomOut"></div>
                    {/* <div className= "bg-title bg-title-right">2004</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2004</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>Baltic states join NATO</div>
                        <div className="content-box">
                            <div className="content-summary">
                                On March 29, 2004, NATO welcomed seven new members: Bulgaria, Romania, Slovakia, Slovenia, Estonia, Latvia and Lithuania. 
                                The latter three are together known as the Baltic states.
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                                From the late 18th to early 20th century, the Baltic states were part of the Russian empire.
                                The three states' coastlines greatly expanded Russia's access to the Baltic Sea, control of which was key to exerting geopolitical influence in Europe. 
                                Wars were fought throughout history for control of the sea and its maritime trade routes.
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'80vh'}}>
                            <div className="content-summary">
                                Initially, the idea of the Baltic nations joining NATO was not well-received by U.S. policymakers, 
                                because of the countries' deep historical ties with Russia. But the Baltic states went out of their way to appeal to the West. 
                                After gaining independence in 1991, these countries were determined to join NATO and the European Union and went through political and economic reforms to meet the entry requirements.
                                <span style={{fontWeight:600,color:'#beab62'}}> In 2004, they became the first post-Soviet states to join NATO.</span>
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            Russian Foreign Minister Sergey Lavrov called NATO's eastward expansion a mistake back in 2004. 
                            ''The presence of American soldiers on our border has created a kind of paranoia in Russia,''
                             Lavrov said in a meeting with NATO ministers in Brussels that year.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2008 */}
                <section className="content-section" style={{paddingBottom:'80vh'}}>
                    <div className="bg bg-zoomOut"></div>
                    {/* <div className= "bg-title">2008</div> */}
                    <div className='content'>
                        <div className="content-time">2008</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>Ukraine asks for membership </div>
                        <div className="content-box">
                            <div className='m_1999_i'>
                                <img src={m_2008_i}/>
                            </div>
                            <div className="content-summary">
                                In March 2008, under Ukrainian President Viktor Yushchenko and Prime Minister Yulia Tymoshenko, Ukraine sent an official letter of application for a Membership Action Plan (MAP), the first step to joining NATO.
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            In April, the NATO summit in Bucharest began with intense debates on whether membership should be extended to Ukraine. Russian President Vladimir Putin was also invited. 
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">While the U.S. and Poland strongly supported Ukraine joining the alliance, the UK, France and Germany contested the idea. In the end, Ukraine was not offered membership, but NATO Secretary General Jaap de Hoop Scheffer promised that the door was open for Ukraine and Georgia to join one day. </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            NATO also said its ballistic missile defense systems deployed in member countries were not directed against Russia, but Putin warned such claims would not ease Russia's concerns. "National security is not based on promises, and the statements made prior to the bloc's previous waves of expansion simply confirm this," Putin said at a press conference following a Russia-NATO meeting on April 4.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2009 */}
                <section className="content-section" data-num = "2009" style={{paddingBottom:'80vh'}}>
                    <div className="bg bg-zoomOut" style={{background:'#000'}}>
                        {/* <div className="shown_up"></div> */}
                        {/* <div className="bg-2009"></div> */}
                        <div className="bg-2009-1"></div>
                        {/* <div className="shown_down"></div> */}
                    </div>
                    {/* <div className= "bg-title bg-title-right">2009</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2009</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>Albania and Croatia join NATO</div>
                        <div className="content-box">
                            <div className="content-summary">
                                In 2009, Albania and Croatia became new inductees of NATO's expanding alliance. With the accession of Albania, most members of the Warsaw Pact aside from Russia have joined NATO.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2013 */}
                <section className="content-section">
                    <div className="bg"></div>
                    {/* <div className= "bg-title">2013</div> */}
                    <div className='content'>
                        <div className="content-time">2013</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>Maidan protests</div>
                        <div className="content-box">
                            <div className="content-summary">
                                In November 2013, waves of protests began in Ukraine after President Viktor Yanukovych turned down an EU-Ukraine Association Agreement and instead pursued closer ties with Russia. The unrest escalated and culminated in February 2014, when clashes between protesters and police became deadly.
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                                To end the bloodshed, on February 21, Yanukovych and leaders of the parliamentary opposition signed an agreement calling for the formation of a coalition government, constitutional reforms and a presidential election by December 2014. But the next day, Yanukovych was voted out of office by the Ukrainian parliament.
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                                Meanwhile, the Crimean parliament stated that because of the events in Kyiv, the autonomous region was ready to join Russia. On February 27, armed men seized the parliament building and raised the flag of the Russian Federation.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2014 */}
                <section className="content-section" data-num = "2014">
                    <div className="bg">
                        <div className = "bg-2014"></div>
                        <div className = "bg-2014-1"></div>
                        <div className = "bg-2014-2"></div>
                    </div>
                    {/* <div className= "bg-title bg-title-right">2014</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2014</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>Crimea crisis</div>
                        <div className="content-box">
                            <div className="content-summary">
                                In a referendum held on March 16, 2014, Russia asked the people of Crimea to decide the peninsula's fate: to join Russia or remain as part of Ukraine. Ninety-seven percent voted to join Russia.
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            On March 18, 2014, the Treaty on Accession of the Republic of Crimea to Russia was signed by representatives of Crimea and Russia, formally admitting Crimea as two Russian federal subjects – the Republic of Crimea and the federal city of Sevastopol. The Ukrainian government did not recognize the referendum. On April 15, the Ukrainian parliament declared Crimea to be a "territory temporarily occupied" by Russia. NATO backed Ukraine, calling the referendum "a direct violation of the Ukrainian constitution and international law."
                            </div>
                        </div>
                        <div className='content-title content-title-blue' style={{textAlign:'right',marginTop:'70vh'}}>Uprisings</div>
                        <div  className='content-title' style={{textAlign:'right'}}>in eastern Ukraine</div>
                        <div className="content-box">
                            <div className="content-summary">
                                Meanwhile, pro-Russian and anti-Maidan demonstrations took place across major cities in southern and eastern Ukraine. In early March, local forces took control of government buildings in Donetsk, Luhansk and Kharkiv oblasts. By mid-May, Donetsk and Luhansk effectively became breakaway regions in Ukraine after both held referendums.
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                                After a previous peace attempt had failed, representatives of Russia, Ukraine, the Organization for Security and Cooperation in Europe (OSCE) and the leaders of the Donetsk and Luhansk regions gathered in Minsk and signed another 15-point agreement in February 2015 known as Minsk II. In the end, the agreement failed to deliver a ceasefire in eastern Ukraine, as Moscow and Kyiv interpreted the pact very differently.
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>

                {/* 2019 */}
                <section className="content-section">
                    <div className="bg"></div>
                    {/* <div className= "bg-title ">2019</div> */}
                    <div className='content'>
                        <div className="content-time">2019</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>Zelenskyy becomes Ukraine's president </div>
                        <div className="content-box" style={{backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                                In 2019, Ukrainian actor and comedian Volodymyr Zelenskyy won a landslide victory against incumbent president Petro Poroshenko. After winning more than 70 percent of the vote in the second round of the contest, he was inaugurated as Ukraine's sixth president on May 20. 
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0',backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            In his campaign, Zelenskyy promised to smooth tensions with Russia and end the conflict in the east of his country. However, Ukraine's ties with NATO deepened as Russia-Ukraine relations continued to deteriorate. In June 2020, Ukraine was <span style={{fontWeight:600,color:"#beab62"}}>recognized by NATO as an Enhanced Opportunities Partner</span>, joining Australia, Finland, Georgia, Jordan and Sweden. NATO claimed the new status did not "prejudge" formal membership, but said Ukraine would continue to receive support from NATO allies "in the security and defense sector."
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh',backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            In 2021, three television channels in Ukraine were shut down for "spreading Russian disinformation." Putin expressed concern that Ukraine was turning into a "polar opposite of Russia," which now required Russia's "special attention from a security point of view."
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0',backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            At the end of 2021, in order to deescalate tensions on the Russia-Ukraine border, Putin urged the West to provide security guarantees which would preclude NATO's expansion into Ukraine and stop the deployment of weapons in the alliance's eastern flank. The West largely ignored Putin's demands and cited NATO's "open-door policy."
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2022 */}
                <section className="content-section" style={{paddingBottom:'35vh'}}>
                    <div className="bg"></div>
                    {/* <div className= "bg-title bg-title-right">2022</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2022</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>Putin recognizes two "independent republics" </div>
                        <div className="content-box">
                            <div className="content-summary">
                            On February 22, 2022, Moscow recognized the "Donetsk People's Republic" and the "Luhansk People's Republic," a move which Kyiv called a violation of Ukraine's sovereignty. Two days later, in a TV address, Putin declared a "special military operation" to "demilitarize" and "denazify" Ukraine would begin. He said the "operation" would not include the occupation of Ukrainian territory. Shortly after, the Russian military launched multiple strikes on dozens of military targets inside Ukraine. 
                            </div>
                        </div>
                        
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>
                    <div className="copy-right">
                        <div>Please note that all maps shown in this interactive product are indicative only, and actual boundaries may vary.</div>
                        <div>Copyright © 2022 CGTN All Rights Reserved.</div>
                    </div>
                </section>
            </div>
        </div>
    }

}

export default M;
